class SideSearch {
  constructor(windowSizes) {
    this.duration = 1.5;
    this.windowSizes = windowSizes;
    this.container = document.querySelector(".search-side");
    if (this.container) {
      this.chipsContainer = this.container.querySelector(".search-side__chips");
      this.selects = this.container.querySelectorAll(".search-side__select");
      this.domainesInput = document.getElementById("search-domaines-input");
      this.departementsInput = document.getElementById(
        "search-departements-input"
      );
      this.caissesInput = document.getElementById("search-caisses-input");
      this.appelsInput = document.getElementById("search-appels-input");
      this.anneesInput = document.getElementById("search-annees-input");
    }
  }

  init() {
    if (this.container) {
      this.initEvents();
    }
  }

  /** Events onChange sur les selects */
  initEvents() {
    Array.from(this.selects, (s, index) => {
      s.addEventListener("change", e => {
        this.onChangeSelect(e);
      });
    });
  }

  /** Désactiver une option
   * après un clic.
   **/
  setOptionDisabled(target, value, disabled) {
    const options = target.getElementsByTagName("option");

    Array.from(options, (o, index) => {
      if (o.value.toLowerCase() == value) {
        o.disabled = disabled;
      }
    });
  }

  /** Reint une select
   * après un clic.
   **/
  setReinitSelect(target) {
    const options = target.getElementsByTagName("option");

    Array.from(options, (o, index) => {
      if (index === 0) {
        o.selected = true;
      }
    });
  }

  /** onChange d'une select +*/
  onChangeSelect(s) {
    /* Désactiver l'option */
    this.setOptionDisabled(s.target, s.target.value, true);
    this.addChip(s.target);
    this.addSearchVar(s.target);
    this.setReinitSelect(s.target);
  }

  addSearchVar(target) {
    switch (target.id) {
      case "search-domaines-select":
        this.domainesInput.value += target.value + ",";
        break;
      case "search-departements-select":
        this.departementsInput.value += target.value + ",";
        break;
      case "search-caisses-select":
        this.caissesInput.value += target.value + ",";
        break;
      case "search-appels-select":
        this.appelsInput.value += target.value + ",";
        break;
      case "search-annees-select":
        this.anneesInput.value += target.value + ",";
        break;
    }
  }

  getOptionName(target, value) {
    const options = target.getElementsByTagName("option");
    let chipName = "";
    Array.from(options, (o, index) => {
      if (o.value.toLowerCase() == value) {
        chipName = o.textContent;
      }
    });
    return chipName;
  }

  /** Créer un chip
   *  avec un bouton fermer.
   **/
  createChip(name) {
    /** New container */
    const newNode = document.createElement("div");
    newNode.className = "chips__el";
    /** New Close Button */
    const newNodeClose = document.createElement("span");
    newNodeClose.className = "chips__el__close";
    newNode.innerHTML = name;
    newNode.appendChild(newNodeClose);
    return newNode;
  }

  onChip(target, value, chip, event) {
    this.setOptionDisabled(target, value, false);
    //target.value = 0;
    chip.remove();
  }

  /** Ajouter une chip avec la valeur
   *  de l'option de la select parente.
   **/
  addChip(target) {
    const value = target.value;
    const chipName = this.getOptionName(target, value);
    const chip = this.createChip(chipName);
    chip.addEventListener("click", c => {
      this.onChip(target, value, chip, event);
    });
    this.chipsContainer.appendChild(chip);
  }

  /** Resize Event */
  resize(windowSizes) {
    this.windowSizes = windowSizes;
  }
}

export default SideSearch;



// WEBPACK FOOTER //
// ./src/js/components/SideSearch.js